<template>
  <div class="min-h-screen flex-1 mt-1 bg-gray-100 px-4 pt-12 shadow-lg items-center">
    <div class="bg-white w-fullrounded-lg shadow">
      
      <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-5">
        <div class="flex">
          <router-link :class="$colors.primary" class="rounded-full bg-primary-600 flex justify-center items-center w-8 h-8 mt-1 mr-3" to="/cashflow">
            <i class="material-icons mx-2">chevron_left</i>
          </router-link>
          <div v-if="!formData._id" class="text-2xl font-bold  capitalize text-primary-600">
            {{ $t('new cashflow') }}
          </div>
          <div v-else class="text-2xl font-bold capitalize text-primary-600">
            {{ $t('edit cashflow') }}
          </div>
        </div>
      </div>

      <div class="">
        <div class="bg-white rounded-lg p-6">
          <div class="space-y-4 px-10">

            <div class="border hover:border-primary-600 w-full focus-within:border-orange-500 focus-within:text-black transition-all duration-500 relative rounded p-1">
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <p>
                  <label for="Libelle" class="bg-white text-gray-700 px-1">{{ $t('Libelle')
                    }}<span :class="$colors.required">*</span></label>
                </p>
              </div>
              <p>
                <input id="Libelle" v-model="formData.libelle" autocomplete="false" tabindex="0" type="text"
                  class="py-2 text-xs px-2 outline-none block h-full w-full" />
              </p>
            </div>

            <div class="border hover:border-primary-600 w-full focus-within:border-orange-500 focus-within:text-black transition-all duration-500 relative rounded p-1">
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <p>
                  <label for="Valeur" class="bg-white text-gray-700 px-1">{{ $t('Valeur') }}
                    <span :class="$colors.required">*</span></label>
                </p>
              </div>
              <p>
                <input id="Valeur" v-model="formData.TotalAmount" autocomplete="false" tabindex="0" type="number"
                  class="py-2 text-xs px-2 outline-none block h-full w-full" />
              </p>
            </div>

            <div class="border hover:border-primary-600 w-full focus-within:border-orange-500 focus-within:text-black transition-all duration-500 relative rounded p-1">
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <p>
                  <label for="Date" class="bg-white text-gray-700 px-1">{{ $t('Date') }}</label>
                </p>
              </div>
              <p>
                <input id="Date" v-model="formData.dateCharge" autocomplete="false" tabindex="0" type="datetime-local"
                  class="py-2 text-xs px-2 outline-none block h-full w-full" />
              </p>
            </div>

          </div>

          <div class="mt-6 pt-3 flex justify-center">
            <button class="rounded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-primary-600 hover:shadow-inner hover:bg-primary-700  transition-all duration-300"
              @click="save">
              {{ $t('save') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        warehouse: null,
        libelle: null,
        TotalAmount: null,
        ValidatedBy: null,
        AddedBy: null,
        status: 'Charge',
        type: 'Manuel',
        color : 'red-500' ,
        dateCharge: null
      },
    };
  },
  async mounted() {
    await this.getwharhouseId();
    this.dataToEdit();
    await this.getUser()
  },
  watch: {
    //  idWharhouse: async function (oldVal, newVal) {
    //   this.idWharhouse = oldVal;
    //   await this.reset();
    // },
  },
  methods: {
    async getwharhouseId() {
      await this.$store.dispatch('wharhouse/getwharhouseId').then(res => {
        this.idWharhouse = res;
        this.formData.warehouse = res._id
      });
    },
    async getUser() {
      const res = await this.$server.me("users");
      if (res.content) {
        this.currentUser = res.content;
        this.formData.AddedBy = res.content._id
      } else { this.currentUser = {} }
    },
    checkData() {
      if (!this.formData['libelle']) return false
      if (!this.formData['TotalAmount']) return false
      if (this.formData['TotalAmount']) {
        const value = parseFloat(this.formData['TotalAmount']);
        if (isNaN(value)) {
          alert(this.$t('enter a valid number'), 'warning');
        } else {
          return true
        }
      }
      return true;
    },
    async save() {
      if (this.formData._id) {
        const data = await this.$server.update('cashflow', this.formData);
        if (data && data._id) alert(this.$t('cashflow updated successfully'), 'success');
      } else {

        if (this.checkData()) {

          const data = await this.$server.create('cashflow', this.formData);

          if (data && data._id) {
            this.formData = {};
            alert(this.$t('cashflow created successfully'), 'success');
          }
        } else {
          alert(this.$t('all feilds are required'), 'warning');
        }
      }
    },
    async dataToEdit() {
      if (this.$route.params.id) {
        const editData = await this.$server.get('cashflow', {
          id: this.$route.params.id,
        });
        this.formData = {
          ...editData.content,
        };
      }
    },
  },
};
</script>